import PropTypes from 'prop-types';
import React, { Component } from 'react';
import socketClient from 'socket.io-client';

import type { AppContext } from '../../components/app-factory/context';

type ClientSocket = typeof socketClient.Socket;

export interface InjectedSocketIoProps {
    io: (namespace: string) => ClientSocket;
}

export default function hoc<T extends InjectedSocketIoProps>(WrappedComponent: React.ComponentType<T>) {
    const ioWithPath = (settings: AppContext['socketIO'], domain: string) => (uri: string) =>
        socketClient(`${domain}${uri}`, {
            ...settings.clientOptions,
            path: settings.mountPath,
            transports: [
                'websocket',
                'flashsocket', // ??
                'htmlfile', // ??
                'xhr-polling',
                'jsonp-polling',
                'polling',
            ],
        });

    return class WithSocketIO extends Component<T> {
        static displayName = `withSocketIO(${WrappedComponent.displayName})`;

        static contextTypes = {
            socketIO: PropTypes.object.isRequired,
            websocketDomain: PropTypes.string.isRequired,
        };

        UNSAFE_componentWillMount() {
            const { websocketDomain, socketIO } = this.context;

            if (typeof window !== 'undefined') {
                this.io = ioWithPath(socketIO, websocketDomain);
            }
        }

        context!: React.ContextType<React.Context<Pick<AppContext, 'socketIO' | 'websocketDomain'>>>;

        io: InjectedSocketIoProps['io'];

        render() {
            return <WrappedComponent {...this.props} io={this.io} />;
        }
    }; //as React.ComponentType<Omit<T, keyof InjectedSocketIoProps>>;
}
